document.addEventListener("DOMContentLoaded", function () {
  // Increment Helpful Count
  const helpfulButtons = document.querySelectorAll(".helpful-btn");
  helpfulButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const countSpan = this.querySelector(".helpful-count");
      let currentCount = parseInt(countSpan.textContent);
      countSpan.textContent = currentCount + 1;
    });
  });

  // Fade Out on Scroll
  window.addEventListener("scroll", function () {
    const reviews = document.querySelectorAll(".review");
    reviews.forEach((review) => {
      const rect = review.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        review.style.opacity = "0.5";
      } else {
        review.style.opacity = "1";
      }
    });
  });
});
